//统一管理api
import { base_roar } from "./base"; // 导入接口域名列表
import { _post } from "./tool"; // 导入http中创建的axios实例
//twitter登录
//兑换历史记录
export const exchangeHistory = (params) => _post(base_roar + "/exchage/history_record", params);

export default { exchangeHistory };
